import { PlusIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import moment from "moment-timezone";
import styles from "./OneDriveBlock.module.css";
const Audio = "/imgs/blocks/windows-audio.png";
const File = "/imgs/blocks/windows-file.png";
const Folder = "/imgs/blocks/windows-folder.png";
const Image = "/imgs/blocks/windows-image.png";
const Photo = "/imgs/blocks/windows-photo.png";
const Video = "/imgs/blocks/windows-video.png";

type Props = {
  mimeType: string;
  name: string;
  modifiedTime: string;
  dndPreview?: boolean;
  id: string;
  onClick?: () => void;
};

function OneDriveBlock({
  mimeType,
  name,
  modifiedTime,
  dndPreview,
  onClick,

  id,
}: Props) {
  const getImgUrl = () => {
    switch (mimeType) {
      case "file":
        return File;
      case "photo":
        return Photo;
      case "image":
        return Image;
      case "video":
        return Video;
      case "audio":
        return Audio;
      case "folder":
        return Folder;
      default:
        return File;
    }
  };

  return (
    <div
      key={id}
      className={clsx(
        styles.lessonBlock,
        "flex w-full flex-1 cursor-pointer flex-col rounded-xl text-sm",
        dndPreview &&
          "border-gray-300 rounded-xl border-b-[1px] bg-white opacity-50"
      )}
      onClick={onClick ? () => onClick() : undefined}
    >
      {dndPreview && (
        <div className={styles.dndPreview}>
          <PlusIcon className={styles.dndPreviewAddIcon} />
        </div>
      )}
      <div className="flex cursor-pointer border-b-[1px] py-4">
        <div className="p-1 px-5">
          <img
            loading="lazy"
            src={getImgUrl()}
            alt={mimeType}
            className="h-5 w-5"
          />
        </div>
        <div className="overflow-hidden text-ellipsis p-1 text-left font-medium text-gray-900">
          {name}
        </div>
        <div className="p-1 px-3 text-gray-500">
          {moment(modifiedTime).format("Do MMM YYYY")}
        </div>
      </div>
    </div>
  );
}

export default OneDriveBlock;
